import React, { useRef, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { termsAndConditions } from "../data/links";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Terms = () => {
  const sectionRefs = useRef([]);

  // Clear refs on re-render
  sectionRefs.current = [];

  const addToRefs = (el) => {
    if (el && !sectionRefs.current.includes(el)) {
      sectionRefs.current.push(el);
    }
  };

  useEffect(() => {
    sectionRefs.current.forEach((el, i) => {
      gsap.fromTo(
        el,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          delay: i * 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        },
      );
    });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />

      <div className="px-4 sm:px-8 md:px-16 lg:px-24 py-16 mx-auto flex flex-col gap-8 items-start max-w-6xl">
        <h1 className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-4">
          Terms & Conditions
        </h1>

        <p className="font-light text-gray-700 text-base sm:text-lg md:text-xl mb-2">
          Welcome to aruhifragrances.com (“Website”), operated by Aruhi
          Fragrances LLC (“Company,” “we,” “us,” or “our”).
        </p>

        <p className="font-light text-gray-700 text-base sm:text-lg md:text-xl mb-6">
          By accessing or using this Website, you agree to comply with and be
          bound by the following Terms & Conditions. Please read them carefully
          before using our services.
        </p>

        {termsAndConditions.map((section, index) => (
          <div key={index} ref={addToRefs} className="w-full mb-8 px-2 sm:px-4">
            <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold mb-3">
              {section.title}
            </h2>
            {section.content.map((line, idx) => (
              <p
                key={idx}
                className="font-light text-gray-700 text-sm sm:text-base md:text-lg mb-1"
              >
                {line}
              </p>
            ))}
          </div>
        ))}
      </div>

      <Footer />
    </>
  );
};

export default Terms;
